// removed by extract-text-webpack-plugin
module.exports = {"component":"_17sgCeBOv1GRCaVCuxyRes","button":"_39HpQBDDlS0gH8DPSak1QT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadActions/MessageThreadActions.css
// module id = 1352
// module chunks = 0